export default __webpack_public_path__ + "static/media/oil.a67d46f3.svg";